import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Episodes from "../pages/episodes/page";
import Analysis from "../pages/analysis/page";
import AnalysisDetail from "../pages/analysis/detail/page";
import Ending from "../pages/ending/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/episodes",
    element: <Episodes />,
  },
  {
    path: "/analysis",
    element: <Analysis />,
  },
  {
    path: "/analysis/:id",
    element: <AnalysisDetail />,
  },
  {
    path: "/ending",
    element: <Ending />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;